import { create } from 'zustand'
import { produce } from 'immer'

export const useConectaPro = create((set) => ({
  data: {
    users: {},
  },
  actions: {
    setUsers: (users) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.users = users;
        }),
      ),
  },
}))
